import React from 'react';
import Select, { SelectValue } from '../../../../Components/Base/Select/Select';
import FormControl from '../../../../Components/Form/FormControl';

interface Props {
	orderOptions: SelectValue[];
	width: number;
	customOnChange?: (item: any) => void;
	enableAutocomplete?: boolean;
}

const GridFilterOrderItem: React.FC<Props> = props => {
	const { orderOptions, width, customOnChange } = props;

	const handleChange = () => {
		customOnChange?.(props);
	};

	return (
		<div style={{ width: width + 'px' }}>
			<FormControl
				labelStyle={{ whiteSpace: 'nowrap' }}
				label='component.gridFilterOrdering.label'
				name='order'
				inLine
				hideRequired
				onChange={handleChange}>
				<Select options={orderOptions} />
			</FormControl>
		</div>
	);
};

export default GridFilterOrderItem;
